<ng-container *ngIf="dialog$ | async as dialog">
  <div class="paybee-modal-header">
    <div class="modal-title">Streaming video: {{ dialog.initialState.streamName }}</div>
  </div>
  <div class="modal-body">
    <video
      class="preview-video"
      width="100%"
      playsinline controls muted
      [src]="dialog.initialState.src">
    </video>

    <div class="row mt-3">
      <div class="col-6 info">
        <div><span> Created On: </span>{{ dialog.initialState.recordedOn | date: 'medium'}}</div>
        <div><span> Download Expires On: </span>{{ dialog.initialState.downloadExpiresOn |  date: 'medium' }}</div>
        <div><span> Size: </span> {{ formatBytes(dialog.initialState.size) }} </div>
      </div>

      <div class="col-6 links">
        <a [href]="dialog.initialState.src" download>
          <div class="download-link"><span>Download</span> <i class="fa fa-download" aria-hidden="true"></i></div>
        </a>
      </div>,
    </div>
  </div>
</ng-container>
